<template>
  <!-- 管理后台根容器 -->
  <div id="app">
    <!-- 路由视图组件，根据当前路由动态加载对应的组件 -->
    <router-view />
  </div>
</template>
  
<script>
export default {
  // 组件名称
  name: "AdminIndex",
  // 组件数据
  data() {
    return {};
  },
};
</script>
  <style scoped>
#app {
  min-height: 100%;
  background-color: #f3f8fd;
}
</style>